import { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import { fetchAd } from "@/lib/api";
import { pickRandomPalette, paletteVars } from "@/lib/palettes";
import { useSeo } from "@/lib/seo";
import { ChevronLeft, ChevronRight, MessageCircle, BadgeCheck, MapPin, User, Ruler, Weight } from "lucide-react";

export default function Detail() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const c = params.get("c") || "";
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIdx, setActiveIdx] = useState(0);
  const P = useMemo(() => pickRandomPalette(`${id}-${Date.now()}`), [id]);

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setActiveIdx(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    onSelect();
  }, [emblaApi, onSelect]);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchAd(id, c).then((data) => {
      if (!alive) return;
      setAd(data);
      setLoading(false);
    });
    return () => { alive = false; };
  }, [id, c]);

  const cityName = ad?.city?.name || "";
  const distName = ad?.district?.name || "";
  const placeLabel = distName ? `${cityName} ${distName}` : cityName;
  const titleStr = ad
    ? `${ad.name} · ${distName ? `${cityName} ${distName}` : cityName} Escort, Gerçek ve Premium Escort İlanları, Sınırsız Eskort`
    : "İlan Detay";
  const descStr = ad
    ? `${ad.name}, ${ad.age} yaşında ${placeLabel} bölgesi vip escort profili. ${ad.description.slice(0, 130)}`
    : "";
  useSeo({ path: `/ilan/${id}`, title: titleStr, description: descStr });

  if (loading) return <div className="np-loading">Yükleniyor…</div>;
  if (!ad) return <div className="np-err">İlan bulunamadı</div>;

  const backUrl = ad.district
    ? `/${ad.city.slug}/${ad.district.slug}/escort`
    : (ad.city ? `/${ad.city.slug}/escort` : "/");
  const backLabel = (distName ? distName : cityName).toLocaleUpperCase("tr-TR") + " ESCORT";

  // Sadece WhatsApp — kisalinks.com/{ad.id}
  const waLink = ad.whatsapp_url || `https://kisalinks.com/${ad.id}`;

  const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
  const scrollNext = () => emblaApi && emblaApi.scrollNext();
  const scrollTo = (i) => emblaApi && emblaApi.scrollTo(i);

  return (
    <div className="np-detail" data-testid="detail-page" style={paletteVars(P)}>
      <header className="np-header">
        <Link to="/" className="np-brand-link">
          <div className="np-brand">
            <span className="np-brand-deco">◆</span>
            <span className="np-brand-nova">NOVA</span>
            <span className="np-brand-amp">&amp;</span>
            <span className="np-brand-platinium">PLATİNİUM</span>
            <span className="np-brand-deco">◆</span>
          </div>
          <div className="np-brand-tagline">PREMİUM ESCORT SİTESİ</div>
        </Link>
      </header>

      <div className="np-back-bar">
        <Link to={backUrl} className="np-back-link" data-testid="detail-back">
          <ChevronLeft size={16} strokeWidth={2.5} />
          <span>{backLabel}</span>
        </Link>
      </div>

      <main className="np-detail-wrap">
        <div className="np-gallery">
          <div className="np-gallery-main">
            {ad.tag && <div className="np-gallery-tag" data-testid="gallery-tag">{ad.tag}</div>}
            {ad.verified && (
              <div className="np-gallery-verified" data-testid="kimlik-onayli">
                <BadgeCheck size={14} strokeWidth={3} />
                <span>KIMLIK ONAYLI</span>
              </div>
            )}

            <div className="np-embla" ref={emblaRef} data-testid="gallery-embla">
              <div className="np-embla-container">
                {ad.gallery.map((src, i) => (
                  <div className="np-embla-slide" key={i}>
                    <img
                      src={src}
                      alt={`${ad.name} - foto ${i + 1}`}
                      className="np-gallery-img"
                      decoding="async"
                      referrerPolicy="no-referrer"
                    />
                  </div>
                ))}
              </div>
            </div>

            <button className="np-embla-prev" onClick={scrollPrev} aria-label="Önceki" data-testid="gal-prev">
              <ChevronLeft size={22} strokeWidth={2.5} />
            </button>
            <button className="np-embla-next" onClick={scrollNext} aria-label="Sonraki" data-testid="gal-next">
              <ChevronRight size={22} strokeWidth={2.5} />
            </button>

            <div className="np-embla-dots">
              {ad.gallery.map((_, i) => (
                <span key={i} className={`np-embla-dot ${i === activeIdx ? "active" : ""}`} />
              ))}
            </div>
          </div>

          <div className="np-gallery-thumbs" data-testid="gallery-thumbs">
            {ad.gallery.map((src, i) => (
              <button
                key={i}
                className={`np-thumb ${i === activeIdx ? "active" : ""}`}
                onClick={() => scrollTo(i)}
                data-testid={`thumb-${i}`}
              >
                <img
                  src={src}
                  alt=""
                  decoding="async"
                  referrerPolicy="no-referrer"
                />
              </button>
            ))}
          </div>
        </div>

        <section className="np-info-card">
          <h1 className="np-name" data-testid="detail-name">
            {ad.name}
            {ad.verified && <BadgeCheck size={20} strokeWidth={3} className="np-name-check" />}
          </h1>
          <div className="np-place">
            <MapPin size={14} strokeWidth={2.5} />
            <span>{placeLabel} ESCORT</span>
          </div>

          <div className="np-stats-row">
            <div className="np-stat-pill"><User size={12} strokeWidth={2.5} /><span>{ad.age} YAŞ</span></div>
            <div className="np-stat-pill"><Ruler size={12} strokeWidth={2.5} /><span>{ad.height} CM</span></div>
            <div className="np-stat-pill"><Weight size={12} strokeWidth={2.5} /><span>{ad.weight} KG</span></div>
          </div>

          <p className="np-desc">{ad.description}</p>

          <a href={waLink} target="_blank" rel="noopener noreferrer" className="np-cta-wa np-cta-wa-full" data-testid="cta-wa">
            <MessageCircle size={20} strokeWidth={2.5} />
            <span>WHATSAPP İLE İLETİŞİM</span>
          </a>
        </section>
      </main>

      <footer className="np-foot">
        <p>© {new Date().getFullYear()} {placeLabel} ESCORT · NOVA &amp; PLATİNİUM</p>
      </footer>
    </div>
  );
}
